module.exports = __webpack_public_path__ + "img/contactBackgroundTopFront.dd8858a6.svg";